import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation } from '@tanstack/react-query';

import { BeraV2Service } from '@/infra/services/bera-v2';

interface UpdateBeraReportV2Params {
	id: string;
	organization_id: string;
	company_id: string;
	task_id?: string;
	task_time?: number;
	task_time_format?: 'minutes' | 'seconds';
	has_known_injury?: boolean;
	collection_date?: string;
	has_no_risk?: boolean;
	step?: number;
}

const Service = BeraV2Service.getInstance();

export function useUpdateBeraReportV2() {
	return useMutation({
		mutationFn: async (params: UpdateBeraReportV2Params) => Service.updateReport(params),
		onError: () => {
			message.error(I18n.get('Failed to save the evaluation'));
		}
	});
}
